import React from "react";

const Footer = () => {
  return (
    <footer className="bg-primary-500 text-center text-white py-4">
      <p className="text-sm">
        FINAL FANTASY is a registered trademark of Square Enix Holdings Co.,
        Ltd. FINAL FANTASY XIV &copy; SQUARE ENIX CO., LTD.
      </p>
    </footer>
  );
};

export default Footer;
